<template>
  <section>
    <div>
      <el-row
        :gutter="5"
        class="el-row"
      >
        <el-upload
          class="upload-demo"
          ref="add-upload"
          :action="UploadUrl()"
          accept=".pdf,image/*"
          capture="camera"
          el-upload
          :on-preview="handlePreview"
          :headers="headers"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-success="handlesuccess"
          :before-upload="handlebefore"
          multiple
          :auto-upload="false"
        >
          <el-button
            type="primary"
            slot="trigger"
            size="small"
          >选取文件</el-button>
          <el-button
            v-loading.fullscreen.lock="loading"
            type="success"
            size="small"
            style="margin-left: 10px;"
            @click="submitUpload('add')"
          >上传到服务器</el-button>
          <div
            slot="tip"
            class="el-upload__tip"
          >文件名中不可含有特殊符号且单个文件不能超过4M</div>
        </el-upload>

        <!-- <label> 筛选状态</label> -->
        <el-button-group>
          <el-button
            type="primary"
            icon="el-icon-arrow-left"
            @click="changeState(0)"
          >未报销</el-button>
          <el-button
            type="primary"
            @click="changeState()"
          >全部</el-button>
          <el-button
            type="primary"
            @click="changeState(1)"
          >已报销<i class="el-icon-arrow-right el-icon--right"></i></el-button>
        </el-button-group>

        <el-button-group style="margin-left: 5px">
          <el-badge
            :value="upcount"
            class="item"
          >
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="dialogTableVisible = true"
            >本次上传</el-button>
          </el-badge>

        </el-button-group>

      </el-row>

      <template>
        <section>
          <!--工具条-->

          <!--列表-->
          <el-main :style="defaultHeight">
            <el-table
              border
              :data="listData"
              highlight-current-row
              @current-change="selectCurrentRow"
              v-loading="listLoading"
              @selection-change="selsChange"
              style="width: 100%;"
            >
              <el-table-column
                type="index"
                width="50"
              >
              </el-table-column>
              <el-table-column
                prop="InvoiceName"
                label="发票名称"
                width="160"
              >

              </el-table-column>
              <el-table-column
                prop="InvoiceNo"
                label="发票号码"
                width="210"
              >
              </el-table-column>
              <el-table-column
                prop="ItemName"
                label="项目名称"
                width="210"
              >
                <template slot-scope="scope">
                  <el-input
                    v-if="scope.row.InvoiceName != '合计'"
                    v-model="scope.row.ItemName"
                    :disabled="scope.row.RBSNo!=0"
                  ></el-input>
                </template>
              </el-table-column>
              </el-table-column>
              <el-table-column
                prop="RB"
                sortable
                label="已用单据"
                width="190"
              >
              </el-table-column>

              <el-table-column
                :formatter="formatData"
                prop="InvoiceDate"
                sortable
                label="开票日期"
                width="190"
              >
                <template slot-scope="scope">
                  <el-date-picker
                    v-if="scope.row.InvoiceName != '合计'"
                    v-model="scope.row.InvoiceDate"
                    align="right"
                    style="width:90%"
                    type="date"
                    :disabled="scope.row.RBSNo!=0"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column
                prop="Amount"
                sortable
                label="金额"
                width="120"
              >
              </el-table-column>
              <el-table-column
                label="图片"
                width="100"
                v-if="isshowpic"
              >
                <template slot-scope="scope">
                  <el-link
                    v-if="scope.row.InvoiceName != '合计'"
                    :href="scope.row.FileName"
                    type="primary"
                    :disabled="scope.row.FileName==''"
                    target=‘_blank’
                  >点击打开</el-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="Count"
                label="张数"
                width="80"
              >
              </el-table-column>
              <el-table-column
                :formatter="formatData2"
                sortable
                prop="CreateTime"
                label="上传日期"
                width="130"
              >
              </el-table-column>
              <el-table-column label="发票状态">

                <template slot-scope="scope">
                  <div
                    v-if="scope.row.InvoiceName != '合计'"
                    slot="reference"
                    class="name-wrapper"
                  >
                    <el-tag
                      size="medium"
                      :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
                    >{{ scope.row.StatusInfo }}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="deleteInvoice(scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                  <el-button
                    @click="updateInvoice(scope.row)"
                    type="text"
                    size="small"
                  >保存</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <!--工具条-->
          <el-col
            :span="24"
            class="toolbar"
          >
            <el-pagination
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="50"
              :total="total"
              style="float:right;"
            >
            </el-pagination>
          </el-col>
        </section>
      </template>

    </div>
    <el-dialog
      title="识别信息"
      :visible.sync="dialogTableVisible"
    >
      <el-table
        :data="gridData"
        id="wl"
      >
        <el-table-column
          type="index"
          width="80"
        >
        </el-table-column>
        <el-table-column
          property="InvoiceNo"
          label="发票号码"
        ></el-table-column>
        <el-table-column
          property="Amount"
          label="金额"
        ></el-table-column>

        <el-table-column
          property="file"
          label="文件名称"
        ></el-table-column>
        <el-table-column
          property="StatusInfo"
          label="发票状态"
        ></el-table-column>

        <el-table-column
          property="CreateTime"
          label="创建日期"
        ></el-table-column>
        <el-table-column
          property="ModifyTime"
          label="修改日期"
        ></el-table-column>
      </el-table>
      <el-button
        @click="exportExcel"
        size="medium"
        type="success"
      >导出</el-button>
    </el-dialog>
  </section>
</template>

<script >
import FileSaver from 'file-saver'
import * as XLSX from 'xlsx'
// import XLSX from 'xlsx'
import util from '../../../util/date'
import Toolbar from "../../components/Toolbar";
import { testapi, getListInvoicePage, removeListInvoice, editListInvoice } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import { Loading } from 'element-ui';
const loadOption = { fullscreen: true, lock: true, text: 'aaaaaa', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' }
let loadingInstance;
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: ''
      },
      headers: {
        Authorization: ''
      },
      defaultHeight: {
        height: ""
      },
      pickerOptions: {
        disabledDate(v) {
          // return v.getTime() < new Date().getTime() - 86400000;
          // return v.getTime() < new Date().getTime() - 86400000;
        }
      },
      dialogTableVisible: false,
      upcount: 0,
      fileList: [],
      huanjing: '',
      state: 2,
      loading: false,
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [],//列表选中列
      UploadPath: '',
      testUploadPath: '',
      DownPath: '',
      testDownPath: '',
      listData: [],
      gridData: [],
      loadingInstance: [],
      isshowpic: false
    }
  },
  methods: {
    UploadUrl: function() {
      var UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;
      return UploadPath;
    },
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 250 + "px";
    },
    handlesuccess(response, file, fileList) {

      if (response.success == true) {
        if (response.response.length > 0) {
          for (let index = 0; index < response.response.length; index++) {
            var tmpresponse = response.response[index];
            this.upcount = this.upcount + 1;
            this.gridData.push({
              // index: upcount,
              InvoiceNo: tmpresponse.InvoiceNo,
              Amount: tmpresponse.Amount,
              file: file.name,
              StatusInfo: tmpresponse.StatusInfo,
              CreateTime: util.formatDate.format(new Date(tmpresponse.CreateTime), 'yyyy-MM-dd'),
              ModifyTime: util.formatDate.format(new Date(tmpresponse.ModifyTime), 'yyyy-MM-dd')
            });

            //如果该发票不在明细内则加入
            if (this.listData.filter((item, i) => {
              return item.InvoiceNo == tmpresponse.InvoiceNo;
            }).length == 0) {
              this.listData.push(tmpresponse); //加到发票明细中
              // fileList.find(a => a.name == file.name).name = tmpresponse.FileName;//文件改名
            }
            else { //如果发票重复上传，自动删除
              const index = fileList.findIndex(text => text.name === file.name);
              fileList.splice(index, 1);
            }
            this.getfpsum()
          }
        }
        else {
          this.upcount = this.upcount + 1;
          this.gridData.push({
            InvoiceNo: '',
            Amount: 0,
            file: file.name,
            StatusInfo: '没有识别到发票',
            CreateTime: '',
            ModifyTime: ''
          });
        }
      }
      else {
        this.$message({
          showClose: true,
          message: response.msg,
          type: 'error',
          duration: 0
        });
      }
      // loadingInstance.close();
      this.loading = false;
    },
    handlebefore(file) {
      // this.sleep(500);
    },
    sleep(n) {
      var start = new Date().getTime();//定义起始时间的毫秒数
      while (true) {
        var time = new Date().getTime();//每次执行循环取得一次当前时间的毫秒数
        if (time - start > n) {//如果当前时间的毫秒数减去起始时间的毫秒数大于给定的毫秒数，即结束循环
          break;
        }
      }
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {

    },
    exportExcel() {
      /* generate workbook object from table */
      let xlsxParam = { raw: true } // 导出的内容只做解析，不进行格式转换
      let wb = XLSX.utils.table_to_book(document.querySelector('#wl'), xlsxParam);//这里的#wl 是表格的id
      /* get binary string as output */
      let wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' });
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '发票识别结果.xlsx');
      } catch (e) {
        if (typeof console !== 'undefined')
          console.log(e, wbout)
      }
      return wbout
    },

    submitUpload(AddorEdit) {
      this.loading = true;
      // loadingInstance = Loading.service({ fullscreen: true });
      this.upcount = 0;
      if (AddorEdit == 'edit') {
        this.$refs['edit-upload'].submit();
      }
      else if (AddorEdit == 'deal') {
        this.$refs['deal-upload'].submit();
      }
      else {
        this.$refs['add-upload'].submit();
      }
    },
    formatData: function(row, column) {
      return (!row.InvoiceDate || row.InvoiceDate == '') ? '' : util.formatDate.format(new Date(row.InvoiceDate), 'yyyy-MM-dd');
    },
    formatData2: function(row, column) {
      return (!row.CreateTime || row.CreateTime == '') ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd');
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleget(this.state);
    },
    changeState(key) {
      this.state = key;
      this.page = 1;
      this.handleget();
    },
    //获取列表
    handleget() {
      let para = {
        page: this.page,
        key: this.state
      };
      this.listLoading = true;
      testapi();
      getListInvoicePage(para).then((res) => {
        var that = this
        that.isshowpic = false
        this.total = res.data.response.dataCount;
        this.listData = res.data.response.data;
        this.listLoading = false;
        for (let i = 0; i < res.data.response.data.length; i++) {
          let item = res.data.response.data[i];
          if (item.FileName.includes("utpscm")) {
            debugger
            that.isshowpic = true;
            break; // 中断整个循环
          }
        }

        console.log(" this.isshowpic", this.isshowpic);
        this.getfpsum();
      });
      console.log(this.listData);
    },
    getfpsum() {
      var that = this;
      const index = that.listData.findIndex(text => text.InvoiceName === '合计');
      if (index != -1) that.listData.splice(index, 1);
      if (that.listData.length > 0) {
        //求合计
        var s = 0;
        var s2 = 0;
        var z1 = '0';
        var z2 = '通过';
        that.listData.forEach(function(val, idx, arr) {
          s += parseFloat(val.Amount);
          s2 += parseFloat(val.Count);
          if (val.Status != '0' && val.Status != '1') {
            z1 = '2';
            z2 = '错误';
          }
        }, 0);
        s = Number(s.toFixed(2));
        // s2 = s2.toFixed(2);

        //判断整体状态
        var heji = {
          InvoiceName: '合计',
          Amount: s,
          ItemName: '',
          Count: s2,
          Status: z1,
          StatusInfo: z2,

          // Amount: 118,
          // BuyCode: null,
          // BuyName: null,
          // Count: 1,
          // CreateBy: "yechen",
          // CreateId: 42,
          // CreateTime: "2022-01-06T16:37:21+08:00",
          // Entry: null,
          // FileName: null,
          // Id: 486,
          // InvoiceCode: null,
          // InvoiceDate: "2022-02-02T00:00:00+08:00",
          // InvoiceName: "手工新增",
          // InvoiceNo: "1010",
          // IsDeleted: false,
          // IsUpByPeo: "1",
          // ItemName: "12333",
          // ModifyBy: "yechen",
          // ModifyId: 42,
          // ModifyTime: "2022-01-06T16:31:18+08:00",
          // RB: "GRBXSQ20220106002",
          // RBSNo: 119,
          // SaleCode: null,
          // SaleContact: null,
          // SaleName: null,
          // Status: "0",
          // StatusInfo: "正确",
          // Type: 99
        };
        that.listData.push(heji);

      }
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    deleteInvoice(row) {
      // const index = this.listData.findIndex(a => a.InvoiceNo === row.InvoiceNo);
      // this.listData.splice(index, 1);
      // const index2 = this.fileList.findIndex(text => text.name === row.FileName);
      // this.fileList.splice(index2, 1);
      this.$confirm('确认删除该发票吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        let para = { Id: row.Id };
        removeListInvoice(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
          this.handleget();
        });
      }).catch(() => {
      });
    },
    updateInvoice(row) {
      this.$confirm('确认修改该发票吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = Object.assign({}, row);
        editListInvoice(para).then((res) => {

          if (util.isEmt.format(res)) {
            this.editLoading = false;
            return;
          }
          if (res.data.success) {
            this.editLoading = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.editFormVisible = false;
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        });
      }).catch(() => {
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeight);
    //一定记得在页面关闭前销毁监听的resize事件，不然多次刷新后页面会因为内存泄漏崩溃
  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.handleget();
    this.state = 2;
    let tokenStr = window.localStorage.Token;
    this.headers = {
      Authorization: "Bearer " + tokenStr
    };
    this.huanjing = process.env.NODE_ENV;
    UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;
    // let routers = window.localStorage.router
    //   ? JSON.parse(window.localStorage.router)
    //   : [];
    //this.buttonList = getButtonList(this.$route.path, routers);
  }
}
</script>
<style>
.scan {
  height: 100%;
}
#bcid {
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 3rem;
  text-align: center;
  color: #fff;
  background: #ccc;
}
footer {
  position: absolute;
  left: 0;
  bottom: 1rem;
  height: 2rem;
  line-height: 2rem;
  z-index: 2;
}
footer button {
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  background-color: #f4f4f4;
  color: #fff;
}
.prev {
  position: absolute;
  display: inline-block;
  height: 0.36rem;
  width: 0.36rem;
  background-size: 0.36rem 0.36rem;
  vertical-align: middle;
  left: 0.18rem;
  top: 0.17rem;
  z-index: 100;
}
</style>